module.exports = __webpack_public_path__ + "media/bundles/TriipApp/assets/images/tab-3-81637ca7af3ca87213eb332b96a5571c.png";